import { Outlet } from 'react-router-dom';

export default function SubmethodFees() {
    return (
        <Outlet />
    )
}
